export default __webpack_public_path__ + "static/Liking_Text2-d03cdd15fcd967f41cd22c623c8a7f73.gif";